/**
 * Bootstrap and the FontAwesome icon font used to be imported here.
 *
 * Both are gone: Bootstrap's .btn / .btn-primary fought the design tokens (it styles
 * buttons through its own --bs-* custom properties), and every icon now comes from
 * react-icons as an inline SVG, so the icon font was dead weight. Nothing in the app
 * depends on either — the form controls and the spinner are ~40 lines in Login.css.
 */
import "./index.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);

reportWebVitals();
